
const reportProductSpecificationForm = (data) => ({
    ...window.helpers,
    specifications: [],
    text: '',
    cad_error: '',
    product: data.product,
    successMessage: data.success_message,
    modalName: data.modal_name,
    email: (window.Alpine.store('user').isLoggedIn) ? window.Alpine.store('user').email : '',
    fieldKeys: ['specifications', 'text', 'email', 'cad_error'],
    addSpecification(id, value) {
        const trimmedValue = typeof value === 'string' ? value.trim() : ''

        // Remove existing values:
        this.specifications = this.specifications.filter((spec) => spec.id !== id)

        if (!trimmedValue) {
            return
        }

        this.specifications.push({
            id,
            value: trimmedValue,
        })
    },
    submitForm() {
        const action = '/api/reportproductspecification'

        this.initAndExecuteGoogleCaptcha(action).then((token) => {
            const formData = new FormData()

            formData.append('product_id', this.product)
            formData.append('captcha_token', token)
            formData.append('captcha_action', action)
            formData.append('cad_error', this.cad_error)
            formData.append('text', this.text)
            formData.append('email', this.email)

            this.specifications.map(
                (specification) => formData.append(`specifications[${specification.id}]`, specification.value),
            )

            this.submitting = true
            this.errors = {}

            window.api.post(action, formData).then((response) => {
                if (response.data.success === true) {
                    this.submitting = false
                    this.successfulSubmission = true
                    this.specifications = []
                    this.cad_error = ''
                    this.text = ''
                    this.errors = {}

                    document.getElementById('reportProductSpecificationForm').reset()
                    this.email = (window.Alpine.store('user').isLoggedIn) ? window.Alpine.store('user').email : ''

                    window.Alpine.nextTick(() => {
                        window.Alpine.store('general').showSpecModal = false
                        window.Alpine.store('general').showOverlay = false
                    })

                    window.dispatchEvent(new CustomEvent('create-toast', {
                        detail: {
                            title: this.modalName,
                            message: this.successMessage,
                            type: 'success',
                        },
                    }))
                } else {
                    this.processServersideErrors(response.data)
                }
            }).catch((error) => {
                this.submitting = false
                this.successfulSubmission = false
                this.processServersideErrors(error.response.data)
            })
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('reportProductSpecificationForm', reportProductSpecificationForm)
})
